module.exports = __webpack_public_path__ + "static/dinda-indra-2f0d8268b03cdbdf29d62c63670f4087.png";